const actions = {
  GET_SUPPORT_DAILOG_STATUS_BEGIN: 'GET_SUPPORT_DAILOG_STATUS_BEGIN',
  GET_SUPPORT_DAILOG_STATUS_SUCCESS: 'GET_SUPPORT_DAILOG_STATUS_SUCCESS',
  GET_SUPPORT_DAILOG_STATUS_ERR: 'GET_SUPPORT_DAILOG_STATUS_ERR',

  SET_SUPPORT_DAILOG_STATUS_BEGIN: 'SET_SUPPORT_DAILOG_STATUS_BEGIN',
  SET_SUPPORT_DAILOG_STATUS_SUCCESS: 'SET_SUPPORT_DAILOG_STATUS_SUCCESS',
  SET_SUPPORT_DAILOG_STATUS_ERR: 'SET_SUPPORT_DAILOG_STATUS_ERR',

  getSupportDailogStatusBegin: () => {
    return {
      type: actions.GET_SUPPORT_DAILOG_STATUS_BEGIN,
    };
  },

  getSupportDailogStatusSuccess: data => {
    return {
      type: actions.GET_SUPPORT_DAILOG_STATUS_SUCCESS,
      data,
    };
  },

  getSupportDailogStatusErr: err => {
    return {
      type: actions.GET_SUPPORT_DAILOG_STATUS_ERR,
      err,
    };
  },

  setSupportDailogStatusBegin: () => {
    return {
      type: actions.SET_SUPPORT_DAILOG_STATUS_BEGIN,
    };
  },

  setSupportDailogStatusSuccess: data => {
    return {
      type: actions.SET_SUPPORT_DAILOG_STATUS_SUCCESS,
      data,
    };
  },

  setSupportDailogStatusErr: err => {
    return {
      type: actions.SET_SUPPORT_DAILOG_STATUS_ERR,
      err,
    };
  },
};

export default actions;
